import { useTranslation } from "react-i18next";
import { setLocale, type UiLocale, uiLocales } from "../../app/i18n.js";

const labels: Record<UiLocale, string> = { "sr-Latn": "SR", en: "EN", ru: "RU" };

export function LocaleSwitch() {
  const { i18n } = useTranslation();
  return (
    <div className="flex gap-1 text-sm">
      {uiLocales.map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLocale(l)}
          className={`rounded-lg px-2 py-1 ${i18n.language === l ? "bg-slate-900 text-white" : "text-slate-500 hover:bg-slate-100"}`}
        >
          {labels[l]}
        </button>
      ))}
    </div>
  );
}
